import { AssetSearch } from "~/v3-poc/features/asset-search/AssetSearch.connector";
import { OrderDetailDialog } from "./OrderDetailDialog.connector";
import { OrderReplacementDialog } from "./OrderReplacementDialog.connector";
import { OrdersCancellationPresentation } from "./OrdersCancellation.pres";
import { OrdersColumnsPopover } from "./OrdersColumnsPopover.connector";
import { OrdersDisplayMenu } from "./OrdersDisplayMenu.connector";
import { OrdersFilters } from "./OrdersFilters.connector";
import { OrdersReplacementFeedbackPresentation } from "./OrdersReplacementFeedback.pres";
import {
  type OrdersWidgetProps,
  useOrdersWidgetController,
} from "./OrdersWidget.controller";
import { OrdersWidgetPresentation } from "./OrdersWidget.pres";

export { formatFailedBatchResults } from "./OrdersCancellation.controller";
export type {
  OrdersWidgetProps,
  OrdersWidgetScope,
} from "./OrdersWidget.controller";

export const OrdersWidget = (props: OrdersWidgetProps = {}) => {
  const {
    assetSearch,
    filters,
    columnsPopover,
    displayMenu,
    cancellation,
    replacementFeedback,
    presentation,
    detailDialogProps,
    replacementDialogProps,
  } = useOrdersWidgetController(props);

  const symbolSearch = assetSearch ? (
    <AssetSearch
      size="1"
      className="orders-symbol-search min-w-24 max-w-56 flex-1 basis-36"
      showFilters={false}
      placeholder="Search symbol"
      aria-label="Search orders by symbol"
      value={assetSearch.value}
      onChange={assetSearch.onChange}
      onSelect={assetSearch.onSelect}
      onClear={() => assetSearch.onChange("")}
    />
  ) : null;

  return (
    <>
      <OrdersWidgetPresentation
        {...presentation}
        filters={
          <OrdersFilters
            {...filters}
            symbolSearch={symbolSearch}
            columnsPopover={<OrdersColumnsPopover {...columnsPopover} />}
          />
        }
        replacementFeedback={
          <OrdersReplacementFeedbackPresentation
            contained={replacementFeedback.contained}
            message={replacementFeedback.message}
            onDismiss={() =>
              replacementFeedback.setReplacementFeedback(undefined)
            }
          />
        }
        cancellationControls={
          <OrdersCancellationPresentation
            selectedCount={cancellation.selectedCount}
            cancellationFeedback={cancellation.cancellationFeedback}
            isBatchCancelling={cancellation.isBatchCancelling}
            isWorkspaceSurface={cancellation.isWorkspaceSurface}
            onClearSelected={cancellation.onClearSelected}
            onRequestBatchCancel={cancellation.onRequestBatchCancel}
            onDismissCancellationFeedback={() =>
              cancellation.setCancellationFeedback(undefined)
            }
          />
        }
        displayMenu={<OrdersDisplayMenu {...displayMenu} />}
        replacePanel={<OrderReplacementDialog {...replacementDialogProps} />}
      />
      <OrderDetailDialog {...detailDialogProps} />
    </>
  );
};
